"use strict";
// Public API of @home-health-notify/auth/web — browser-targeted SSO.
//
// Pairs with the core entry point (@home-health-notify/auth) for the shared
// React bindings (AuthProvider, useAuth, SessionManager, IAuthAdapter, types).
//
// `AmplifyAuthAdapter` lives in core now that native uses it too (via
// @aws-amplify/rtn-web-browser). This subpath still exists for the
// web-specific UI (HTML/CSS LoginScreen + ChangePasswordForm) and the
// web-flavored createSessionManager factory.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordForm = exports.LoginScreen = void 0;
// LoginScreen — drop-in UI, defaults to HHN brand
var LoginScreen_1 = require("./LoginScreen");
Object.defineProperty(exports, "LoginScreen", { enumerable: true, get: function () { return LoginScreen_1.LoginScreen; } });
// ChangePasswordForm — drop-in form contents (host wraps in own dialog).
var ChangePasswordForm_1 = require("./ChangePasswordForm");
Object.defineProperty(exports, "ChangePasswordForm", { enumerable: true, get: function () { return ChangePasswordForm_1.ChangePasswordForm; } });
// Note: AmplifyAuthAdapter, AmplifyConfig, and createSessionManager now
// live in the root entry (@home-health-notify/auth). They used to be
// exported from here too — that shim is gone as of the unified adapter
// migration. Update any imports:
//
//   - import { createSessionManager } from "@home-health-notify/auth/web";
//   + import { createSessionManager } from "@home-health-notify/auth";
//
// The /web subpath now ships ONLY the DOM-specific UI + styles.
